import { getSplitCookieValue } from './cookies'

/**
 * Helper to allow easily grabbing a users experiment status as a boolean.
 * Add your experiments to the constant and use the helper like so:
 *
 * isInExperiment(SPLIT_EXPERIMENTS.GIFT_GIVER_THANK_YOU_NOTES)
 */

export const SPLIT_EXPERIMENTS = {
  GIFT_GIVER_THANK_YOU_NOTES: 'gift_giver_thank_you_notes',
}

const isInExperiment = (
  experimentName: string,
  experimentGroup = 'experiment'
) => getSplitCookieValue(experimentName) === experimentGroup

export default isInExperiment
